module.exports = __webpack_public_path__ + "img/pro1.c6c41c05.png";